import type { StateCreator } from "zustand";

export interface CsvExportSlice {
    isCsvExporting: boolean;
    /** False when an export is already running. Synchronous, so a second click can't slip in before a re-render. */
    beginCsvExport: () => boolean;
    endCsvExport: () => void;
}

export const createCsvExportSlice: StateCreator<CsvExportSlice, [], [], CsvExportSlice> = (set, get) => ({
    isCsvExporting: false,
    beginCsvExport: () => {
        if (get().isCsvExporting) return false;
        set({ isCsvExporting: true });
        return true;
    },
    endCsvExport: () => set({ isCsvExporting: false }),
});
